import { Filter, Sort } from '@/components/icons';
import FilterModal from '@/components/ui/modals/category-filter-modal';
import useCart from '@/store/cart.store';

const MobileFilters = ({
  ref,
  t,
  buttonStyles,
  setModalType,
  modalType,
  filters,
  onFilter,
  handleSorting,
  searchIndexName,
  isFromSearch,
}) => {
  const cartItems = useCart((state) => state.cartItems);

  return (
    <>
      <div
        className={`fixed start-1/2 ${cartItems?.length > 0 ? 'bottom-26' : 'bottom-10'} z-49 col-span-full mb-4 w-11/12 grid-cols-2 gap-0.5 pb-2 max-[768px]:grid ltr:-translate-x-1/2 rtl:translate-x-1/2`}
      >
        {[
          { key: 'filter', icon: <Filter />, text: t('filter_key') },
          { key: 'sortBy', icon: <Sort />, text: t('sort_by_key') },
        ].map(({ key, icon, text }) => (
          <button
            key={key}
            onClick={() => setModalType(key)}
            className={`${buttonStyles} flex items-center justify-center rounded-[10px] p-2 ${key === 'filter' ? 'rounded-e-none!' : 'rounded-s-none!'}`}
          >
            {icon}
            <span className='mx-2.75 max-[991px]:text-sm'>{text}</span>
          </button>
        ))}
      </div>

      {/* <button
        className={`fixed right-5 ${cartpopup ? 'bottom-30' : 'bottom-16'} z-20 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--brand,#1e2b55)] text-white shadow-lg`}
        onClick={() => setModalType('filter')}
        aria-label='فتح التصفية'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='h-6 w-6'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L14 14.414V20a1 1 0 01-1.447.894l-4-2A1 1 0 018 18v-3.586L3.293 6.707A1 1 0 013 6V4z'
          />
        </svg>
      </button> */}
      {/* Modal */}
      {modalType && (
        <FilterModal
          type={modalType}
          t={t}
          ref={ref}
          filters={filters}
          onFilter={onFilter}
          setModalType={setModalType}
          handleSorting={handleSorting}
          searchIndexName={searchIndexName}
          isFromSearch={isFromSearch}
        />
      )}
    </>
  );
};

export default MobileFilters;
